import { Pipe, PipeTransform } from '@angular/core';
import { ActionTypes } from 'src/app/models/api/playbooks/actions/actionTypes.enum';
import {
  PowerplatformAgentActionAuthenticationMode,
  PowerplatformAgentActionConfirmationMode,
  PowerplatformAgentActionSetAuthenticationModePayload,
  PowerplatformAgentActionSetConfirmationModePayload,
  PowerplatformAgentActionSetWebBrowsingPayload,
  PowerplatformEnvironmentSetAuditPayload,
} from 'src/app/services/httpServices/actionsHttpService/actions-http-service.service';
import { PlaybookActionDefinitionPropertiesBase } from 'src/app/models/api/playbooks/playbook.model';

@Pipe({
  name: 'displayActionName',
  standalone: true,
})
export class DisplayActionNamePipe implements PipeTransform {
  transform(actionType: ActionTypes, actionDefinitionProperties: PlaybookActionDefinitionPropertiesBase): ActionTypes {
    switch (actionType) {
      case ActionTypes.setAgentActionAuthenticationMode:
        return (actionDefinitionProperties as PowerplatformAgentActionSetAuthenticationModePayload)
          .authenticationMode === PowerplatformAgentActionAuthenticationMode.invoker
          ? ActionTypes.setUserContext
          : ActionTypes.setAuthorContext;
      case ActionTypes.setAgentActionConfirmationMode:
        return (actionDefinitionProperties as PowerplatformAgentActionSetConfirmationModePayload).confirmationMode ===
          PowerplatformAgentActionConfirmationMode.strict
          ? ActionTypes.setStrictConfirmationMode
          : ActionTypes.setDisabledConfirmationMode;
      case ActionTypes.setAgentWebBrowsing:
        return (actionDefinitionProperties as PowerplatformAgentActionSetWebBrowsingPayload).isWebBrowsingEnabled
          ? ActionTypes.enableWebBrowsing
          : ActionTypes.disableWebBrowsing;
      case ActionTypes.setEnvironmentAudit:
        return (actionDefinitionProperties as PowerplatformEnvironmentSetAuditPayload).isAuditEnabled
          ? ActionTypes.enableEnvironmentAudit
          : ActionTypes.disableEnvironmentAudit;
      default:
        return actionType;
    }
  }
}
